import { CreditInfo, Order } from '../services/types';

export const flattenOrders = (orders: Order[] = []) => {
  return (orders ?? [])
    .flatMap(order => 
      (order.shipments ?? []).flatMap(shipment => {
        if (!shipment) return [];

        return {
          orderId: order.orderId,
          billingDate: order.billingDate,
          orderShipmentId: shipment.shipmentDetails?.orderShipmentId ?? '',
          trackingNumber: shipment.shipmentDetails?.trackingNumber ?? '',
          status: shipment.shipmentDetails?.status ?? '',
          carrier: shipment.shipmentDetails?.carrier ?? '',
        };
      })
    )
    .reduce((acc, shipment, index) => {
      const i = index + 1;
      acc[`orderId${i}`] = shipment.orderId;
      acc[`billingDate${i}`] = shipment.billingDate;
      acc[`orderShipment${i}`] = shipment.orderShipmentId;
      acc[`trackingNumber${i}`] = shipment.trackingNumber;
      acc[`status${i}`] = shipment.status;
      acc[`carrier${i}`] = shipment.carrier;
      return acc;
    }, {} as Record<string, string | number>);
}



export const formatCredits = (credits: CreditInfo[]): string => {
  return credits
    .map(
      (credit, index) => `Credit #${index + 1}: '${credit.creditName}', amount: ${credit.amount}`,
    )
    .join('; ');
};
